import gql from 'graphql-tag';

export const GET_PROPOSAL_MENUS = gql`
  query ProposalMenus {
    proposalMenus(input: {}) {
      proposalMenuId
      name
      description
      menuOptions {
        name
        ordinal
        description
        proposalMenuOptionId
        titleBgColor
        titleColor
        type
        products {
          cost
          retailCost
          title
          ordinal
          proposalProductId
          thirdPartyUrl
          accountIdCreatedBy
          aftermarketProductToPartnerLinkId
          aftermarketProduct {
            aftermarketProductId
            aftermarketVendorApiChannel
            productIsNoLongerAvailable
            externalId
            productName
            productType
            productCategory
            productDescriptionExternal
            criteria
            productLogoUrl
            config {
              criteriaValues
            }
            aftermarketProductCatalogDetails {
              productSummary
              limitationsOfLiability
              eligibilityAndInclusions
              legalDisclaimer
              paragraphDescription
              coverageDetails
            }
            documents {
              documentId
              docName
              source
            }
          }
          markup {
            type
            markup
          }
        }
      }
    }
  }
`;
